import React, { FC } from 'react';

import { IconCTAProps } from 'Src/components/buttons/IconCTA';
import FontIcon from 'Src/components/icons/FontIcon';

import { CTAKeyOption, CTAKeys } from '../soft-keyboard/CTAKeys';

const actionKeyMap = {
  ['backspace']: {
    value: 'backspace',
    icon: <FontIcon name="backspace" />,
    label: undefined,
    variant: 'no-background'
  },
  ['doubleZero']: {
    value: 'doubleZero',
    label: '00',
    variant: 'outlined',
  },
  ['send']: {
    value: 'send',
    icon: <FontIcon name="check" />,
    label: undefined,
    color: 'primary',
  }
} as const;

type NumericInputKeys = (Omit<CTAKeyOption, 'onClick' | 'disabled' | 'value'> & { value: number | string })[];

type NumericKeyboardProps = {
    size?: IconCTAProps['size'];
    value?: number;
    onChange: (value?: string) => void;
    type: 'tel';
    isValid?: boolean;
    onSubmit: () => void;
    };

const getKeyboardLayout = (type: string) => {
  let bottomLayout: NumericInputKeys = [];
  switch (type) {
    case 'tel':
      bottomLayout = [
        actionKeyMap.backspace,
        { value: 0, label: '0', variant: 'outlined' },
        actionKeyMap.send
      ];
      break;
  
    default:
      break;
  }
  return [
    // row 1
    { value: 1, label: '1', variant: 'outlined' },
    { value: 2, label: '2', variant: 'outlined' },
    { value: 3, label: '3', variant: 'outlined' },
    // row 2
    { value: 4, label: '4', variant: 'outlined' },
    { value: 5, label: '5', variant: 'outlined' },
    { value: 6, label: '6', variant: 'outlined' },
    // row 3
    { value: 7, label: '7', variant: 'outlined' },
    { value: 8, label: '8', variant: 'outlined' },
    { value: 9, label: '9', variant: 'outlined' },
    // row 4
    ...bottomLayout,
      
  ] as NumericInputKeys;
};

const NumericKeyboard: FC<NumericKeyboardProps> = ({ size, value, isValid, onSubmit, onChange, type }) => {
  const nextValue = value?.toString() || '';
  const keys = getKeyboardLayout(type);
  return (
    <CTAKeys
      size={size}
      options={keys.map((key) => ({
        ...key,
        disabled: key.value === actionKeyMap.send.value && !isValid,
        onClick: (event, option) => {
        // append to the value
          if (typeof option.value === 'number') {
            const resultValue = `${nextValue}${option.value}`;
            if (onChange) onChange(resultValue);
            return;
          }
          // append double zero to the value
          if (option.value === actionKeyMap.doubleZero.value) {
            const resultValue = `${nextValue}00`;
            if (onChange) onChange(resultValue);
            return;
          }
          // remove from the value
          if (option.value === actionKeyMap.backspace.value) {
            let resultValue;
            if (nextValue?.length) {
              const characters = nextValue.split('');
              // remove last part
              characters.pop();
              resultValue = characters.length ? characters.join('') : '0';
            }
            if (onChange) onChange(resultValue);
            return;
          }

          if (option.value === actionKeyMap.send.value) {
            if (isValid) {
              onSubmit();
            }
          }
        },
      }))}
    />
  );};

export { NumericKeyboard };
